import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=5a2ddb6c"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"
import style0 from "./detailList.vue?vue&type=style&index=0&id=5a2ddb6c&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports